<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" icon> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-4 pb-4">
      <div style="font-weight: 600; font-size: 22px" class="primary--text mb-3">
        รายละเอียดบรอดแคสต์
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('ชื่อบรอดแคสต์') }">
        <input
          :disabled="edittype == 'read'"
          placeholder="กรอกชื่อบรอดแคสต์"
          v-model="input.title"
          type="text"
          name="ชื่อบรอดแคสต์"
          v-validate="'required'"
        />
        <p class="text-error" v-if="errors.has('ชื่อบรอดแคสต์')">
          {{ errors.first('ชื่อบรอดแคสต์') }}
        </p>
      </div>
      <div class="my-3">
        <v-divider></v-divider>
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('เลือกประเภท') }">
        <v-radio-group
          :disabled="edittype == 'read'"
          row
          v-model="radiochannel"
          v-validate="'required'"
          name="เลือกประเภท"
        >
          <v-radio label="ทั้งหมด" value="all" color="primary"></v-radio>
          <v-radio label="เลือก LINE OA" value="custom" color="primary"></v-radio>
        </v-radio-group>
        <p class="text-error" v-if="errors.has('เลือกประเภท')">
          {{ errors.first('เลือกประเภท') }}
        </p>
      </div>
      <div class="mb-3">
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือกกลุ่ม') }"
        >
          <multiselect
            :loading="loadinggroup"
            @input="onChangeGroup"
            :disabled="edittype == 'read'"
            placeholder="เลือกกลุ่ม"
            name="เลือกกลุ่ม"
            track-by="id"
            label="name"
            :options="groupOptionsFiltered"
            :show-labels="false"
            :custom-label="customLabel"
          ></multiselect>
          <p class="text-error" v-if="errors.has('เลือกกลุ่ม')">
            {{ errors.first('เลือกกลุ่ม') }}
          </p>
        </div>
      </div>
      <div>
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือก Line OA') }"
        >
          <multiselect
            :disabled="edittype == 'read'"
            v-validate="'required'"
            placeholder="เลือก Line OA"
            name="เลือก Line OA"
            track-by="id"
            :key="keychannels"
            label="channelname"
            v-model="input.channellist"
            :options="filteredChannels"
            @remove="keychannels++"
            multiple
            :show-selected="false"
          ></multiselect>
          <p class="text-error" v-if="errors.has('เลือก Line OA')">
            {{ errors.first('เลือก Line OA') }}
          </p>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <div :style="edittype == 'read' ? 'pointer-events: none;' : ''" class="mb-3">
        <intent-group
          :key="keymessage"
          v-model="messages"
          :hasAlternative="false"
          :isWelcome="true"
        ></intent-group>
      </div>
      <div class="mb-3">
        <v-checkbox
          :disabled="edittype == 'read'"
          v-model="input.signaturestatus"
          :label="`ใช้ Signature`"
        ></v-checkbox>
      </div>
      <div class="form-control mb-2">
        <label style="font-size: 14px; color: #666">ข้อความแจ้งเตือน</label>
        <input
          placeholder="คุณได้รับรูปภาพ"
          v-model="input.notify"
          type="text"
          name="ข้อความแจ้งเตือน"
          class="mt-2"
        />
      </div>
      <div :style="edittype == 'read' ? 'pointer-events: none;' : ''">
        <div>ตั้งเวลา บรอดแคสต์</div>
        <div>
          <v-layout row wrap class="ma-0">
            <v-flex xs4>
              <DatepickerCustomDialog v-model="selectedDate" class="form-control">
                <input
                  placeholder="DD/MM/YYYY"
                  readonly
                  :value="getDateFormatted(selectedDate)"
                  type="text"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <CustomTimepicker v-model="selectedTime" class="form-control">
                <input placeholder="00:00" readonly :value="selectedTime" type="text" />
              </CustomTimepicker>
            </v-flex>
            <v-flex>
              <v-btn @click="clearDateTime" icon> <v-icon>close</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-if="edittype !== 'read'" class="text-xs-center">
        <v-btn @click="$emit('close')" outline color="grey">ยกเลิก</v-btn>
        <v-btn :loading="saveloading" @click="onSave(false)" outline color="grey"
          >บันทึกฉบับร่าง</v-btn
        >
        <v-btn :loading="saveloading" @click="onSave(true)" depressed color="primary">
          {{ edittype == 'edit' ? 'ส่ง' : 'ส่ง' }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import IntentGroup from '@/components/view/intent/IntentGroup'
import uploadfile from '@/components/elements/uploadfile.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    multiselect,
    uploadfile,
    IntentGroup,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  props: ['edittype', 'editdata', 'channels', 'groupOptions', 'loadinggroup'],
  computed: {
    groupOptionsFiltered() {
      if (this.groupOptions) {
        return this.groupOptions.map((group) => {
          var channels = this.filteredChannels.filter((val) =>
            val.groupids ? val.groupids.includes(parseInt(group.id)) : false
          )
          return {
            ...group,
            total: channels.length,
            $isDisabled: channels.length == 0
          }
        })
      } else return []
    },
    ...mapGetters(['selectedBot']),
    filteredChannels() {
      return this.channels.filter((el) => {
        return el.app == 'line'
      })
    }
  },
  data() {
    return {
      keymessage: 0,
      selectedDate: '',
      selectedTime: '',
      keychannels: 0,
      saveloading: false,
      radiochannel: '',
      messages: [[]],
      input: {
        title: '',
        photoUrl: '',
        channellist: []
      }
    }
  },
  mounted() {
    if (this.edittype == 'edit' || this.edittype == 'read') {
      this.input = this.editdata
      this.input.photoUrl = this.editdata.photourl
      this.radiochannel = 'custom'
      this.messages = this.editdata.messages
      if (this.editdata.scheduletime) {
        var datetime = this.editdata.scheduletime.split(' ')

        this.selectedDate = datetime[0]
        this.selectedTime = datetime[1]
      }

      this.keymessage++
      this.input.channellist = this.filteredChannels.filter((el) => {
        return this.editdata.channelidlist.includes(el.channelid)
      })

      this.input.signaturestatus = this.editdata.signaturestatus
    } else {
      this.input.signaturestatus = true
    }
  },
  methods: {
    customLabel(item) {
      return `${item.name} (${item.total})`
    },
    onChangeGroup(group) {
      this.input.channellist = this.filteredChannels.filter((el) =>
        el.groupids ? el.groupids.includes(parseInt(group.id)) : false
      )
      this.keychannels++
    },
    clearDateTime() {
      this.selectedDate = ''
      this.selectedTime = ''
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else return ''
    },
    async onSave(isPublish) {
      if (await this.$validator.validate()) {
        if (this.edittype == 'create') {
          this.createData(isPublish)
        } else {
          this.editData(isPublish)
        }
      }
    },
    sendPost(data) {
      api.powerbuySendFacebookPost(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onSave')
        }
      })
    },
    createData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }
      var scheduleTime
      if (this.selectedDate) {
        scheduleTime = moment(this.selectedDate).format('YYYY-MM-DD')
        scheduleTime += ' ' + (this.selectedTime ? this.selectedTime : '00:00')
      }
      var data = {
        pageid: this.selectedBot.pageid,
        title: this.input.title,
        channelIdList, // array channelid
        messages: this.messages,
        scheduleTime,
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus,
        notify: this.input.notify
      }
      api.createPowerbuyLineBroadcast(data, (err, response) => {
        this.saveloading = false
        this.$emit('onSave')
      })
    },
    editData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }
      var scheduleTime
      if (this.selectedDate) {
        scheduleTime = moment(this.selectedDate).format('YYYY-MM-DD')
        scheduleTime += ' ' + (this.selectedTime ? this.selectedTime : '00:00')
      }
      var data = {
        id: this.editdata.id,
        pageid: this.selectedBot.pageid,
        title: this.input.title,
        channelIdList, // array channelid
        messages: this.messages,
        scheduleTime,
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus,
        notify: this.input.notify
      }
      api.editPowerbuyLineBroadcast(data, (err, response) => {
        this.saveloading = false
        this.$emit('onSave')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/LineBroadcast/PostEdit.vue